"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M8 3C8 1.89543 8.89543 1 10 1H18C19.1046 1 20 1.89543 20 3V16H8V3Z", fill: "currentColor" }),
    react_1.default.createElement("rect", { x: "5", y: "17", width: "18", height: "3", rx: "1", fill: "currentColor" }),
    react_1.default.createElement("rect", { x: "13", y: "20", width: "2", height: "5", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M16 25C16.5523 25 17 25.4477 17 26L17 27L11 27L11 26C11 25.4477 11.4477 25 12 25L16 25Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12V16H5V12Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M21 12C21 11.4477 21.4477 11 22 11C22.5523 11 23 11.4477 23 12V16H21V12Z", fill: "currentColor" })));
